module.exports = __webpack_public_path__ + "img/IMG_9033_L_Wood_MockedUp.087183c5.jpg";